import useProdDetail from '../../application/bloc/useProdDetail';
import { FlexBox, ListWithGap, SideBox } from '../etc/LBox/LBox';
import {
  Skeleton,
  DetailItemB,
  Button,
  Description,
  Popup,
  Spacer,
  TextButton,
  SimpleItem,
} from 'oui';
import RateCalcBottomSheet from '../feedback/RateCalcBottomSheet/RateCalcBottomSheet';
import { addUnitToMaxAmount } from '../../application/helper/filter';
import useRateCalcBottomSheet from '../../application/hooks/useRateCalcBottomSheet';
import { RATE_CALC_BANNER } from '../../application/staticData/Banner/RATE_CALC_BANNER';

const ProdDetail = () => {
  const {
    productOptions,
    custProductDetailItem,
    productInfo,
    isLoading,
    hashTagList,
    isLoanComplete,
    btnText,
    sendBeaconLoanApp,
    sendBeaconLoanCncl,
    sendBeaconClkBtnIntrstCalc,
    cancelLoan,
    navigateExternal,
    popup,
    custPreProductInfo,
  } = useProdDetail();

  const { isBottomSheetOpen, onClickOpenBottomSheet, onClickCloseBottomSheet } =
    useRateCalcBottomSheet();

  const handleClickTextButton = (e: any) => {
    sendBeaconLoanCncl(e.target.innerText ?? '');
    cancelLoan();
  };

  const handleClickLoanDetailButton = (e: any) => {
    sendBeaconLoanApp(e.target.innerText ?? '');
    navigateExternal();
  };

  const handleClickOpenBottomSheet = () => {
    sendBeaconClkBtnIntrstCalc('이자 계산기');
    onClickOpenBottomSheet();
  };

  const handleClickCloseBottomSheet = () => {
    onClickCloseBottomSheet();
  };

  return (
    <>
      {isLoading ? (
        <Skeleton type={'b'} />
      ) : (
        <>
          <DetailItemB
            textTitle={productInfo?.compNm}
            subTitle={productInfo?.productNm}
            avatar={{
              source: productInfo?.logoImgUrl,
              alt: productInfo?.compNm ?? 'logo',
            }}
            labelA={'금리'}
            labelB={'한도'}
            valueA={`${
              isLoanComplete
                ? custProductDetailItem?.interestRate
                : custPreProductInfo?.interestRate
            }%`}
            valueB={addUnitToMaxAmount(
              isLoanComplete
                ? custProductDetailItem?.amount
                : custPreProductInfo?.amount,
            )}
            eventChip={hashTagList}
          />
          <ListWithGap gap={0}>
            <Button
              configuration={'contained'}
              flexible={true}
              children={btnText}
              onClick={handleClickLoanDetailButton}
            />
          </ListWithGap>
          {!isLoanComplete && (
            <SideBox>
              <FlexBox justify="end">
                <TextButton
                  size="md"
                  state="enabled"
                  text="대출 취소하기"
                  onClickButton={handleClickTextButton}
                />
              </FlexBox>
              <Spacer size={'md'} />
            </SideBox>
          )}
          <SideBox>
            <Spacer size={'xs'} />
            <SimpleItem
              avatar={{
                source: RATE_CALC_BANNER[0].logoImgUrl,
                alt: RATE_CALC_BANNER[0].primaryText,
              }}
              headerText={RATE_CALC_BANNER[0].primaryText}
              subheaderText={RATE_CALC_BANNER[0].secondaryText}
              onClickSimpleItem={handleClickOpenBottomSheet}
              state={'enabled'}
            />
            <Spacer size={'md'} />
          </SideBox>
          {productOptions?.length > 0 && (
            <Description
              productOptions={productOptions}
              infoText={productInfo?.infoText}
            />
          )}

          <Popup
            title={popup.message}
            isPopupOpen={popup.open}
            confirmBtn={{
              text: popup.confirmText,
              onClick: popup.handleClickConfirm,
            }}
            cancelBtn={{
              text: popup.cancelText,
              onClick: popup.handleClickCancel,
            }}
          />
          <RateCalcBottomSheet
            isShow={isBottomSheetOpen}
            handleClickOpenBottomSheet={handleClickOpenBottomSheet}
            handleClickCloseBottomSheet={handleClickCloseBottomSheet}
            preset={{
              amount: (custProductDetailItem?.amount / 10000).toString(),
              interestRate: custProductDetailItem?.interestRate.toString(),
              term: '60',
              maxTerm: 120,
            }}
          />
        </>
      )}
    </>
  );
};

export default ProdDetail;
